import { Voucher } from "types";

const transformVoucher = (data: any): Voucher => {
  const {
    _id,
    title,
    code,
    description,
    discount,
    initialQuantity,
    usedQuantity,
    availableQuantity,
    createdAt,
    startDate,
    endDate,
    balanceDescription
  } = data;

  return {
    id: _id,
    code,
    name: title,
    description,
    discount,
    count: initialQuantity,
    used: usedQuantity,
    available: availableQuantity,
    createdAt,
    startAt: startDate,
    endAt: endDate,
    balanceDescription
  };
};

export { transformVoucher };
